import {Alert, Layout, Typography} from '@hub-mono/ui';
import React, {useId, useMemo} from 'react';
import {Button, UncontrolledCollapse} from 'reactstrap';

export const ModalSectionHeader = React.memo(props => {
    const { title, subtitle, helperText } = props;
    const tempId = useId();

    const id = useMemo(() => {
        return tempId.replaceAll(':', '')
    }, [tempId]);
    
    return (
        <Layout stack gap="--Spacing-150">
            <Layout hAlign="space-between" vAlign="center" gap={24}>
                <Layout gap="--Spacing-150" stack>
                    <Typography variant="label" size="large" prominent>
                        {title}
                    </Typography>
                    <Typography variant="body" size="small" color="on-surface-variant">
                        {subtitle}
                    </Typography>
                </Layout>
                <Button color="link sm float-right m-0 p-0" id={`toggler${id}`}>
                    help?
                </Button>
            </Layout>
            <UncontrolledCollapse toggler={`#toggler${id}`}>
                <Alert variant="info">{helperText ? helperText : null}</Alert>
            </UncontrolledCollapse>
        </Layout>
    );
});
